<div class="portal-page-content">
  @if (!loaded) {
    <div class="waiting-spinner">
      <mat-spinner strokeWidth="2" diameter="50"></mat-spinner>
      <p>Loading...</p>
    </div>
  }
  <app-portal-in-progress-credential
    (loaded)="inProgressLoaded = true"
  ></app-portal-in-progress-credential>
  @if (loaded) {
    @for (credentialGroup of credentialGroupResults; track credentialGroup) {
      <div class="credential-group-container">
        <h2>{{ credentialGroup.groupName }}</h2>
        @if (
          !credentialGroup.credentials ||
          credentialGroup.credentials.length == 0
        ) {
          <p class="no-credential-text">
            You have no {{ credentialGroup.groupName }}
          </p>
        }
        @for (credential of credentialGroup.credentials; track credential) {
          <section class="page-section credential-section">
            <div class="mt-1 header-row">
              <div class="header-text">
                <h3 class="credential-name">{{ credential.credentialName }}</h3>
              </div>
              <div class="download-pdf">
                @if (credential.hasPdfAvailable) {
                  <div class="download-pdf-container">
                    <button
                      mat-button
                      color="primary"
                      class="secondary-button"
                      aria-label="Download pdf"
                      (click)="downloadPdf(credential)"
                    >
                      <mat-icon color="primary" class="md-18"
                        >file_download</mat-icon
                      >
                      Download
                    </button>
                  </div>
                }
                <div class="rounded">
                  <span>
                    <svg width="10" height="10" class="mr-1">
                      <circle
                        [ngClass]="getColor(credential)"
                        class="status-dot"
                        cx="5"
                        cy="5"
                        r="4"
                        stroke-width="0"
                      />
                    </svg>
                    {{ getLabel(credential) }}
                  </span>
                </div>
              </div>
            </div>
            <table class="credential-info-table">
              <tr>
                <td><b>Number</b></td>
                <td>
                  {{
                    credential.credentialNumber
                      ? credential.credentialNumber
                      : 'Not Issued'
                  }}
                </td>
              </tr>
              <tr>
                <td><b>Issue Date</b></td>
                <td>
                  {{
                    credential.issueDate
                      ? (credential.issueDate | date: 'mediumDate')
                      : 'Not Issued'
                  }}
                </td>
              </tr>
              <tr>
                <td><b>Expiration Date</b></td>
                <td>
                  {{
                    credential.expirationDate
                      ? (credential.expirationDate | date: 'mediumDate')
                      : 'Not Issued'
                  }}
                </td>
              </tr>
              @if (
                credential.specialties && credential.specialties.length > 0
              ) {
                <tr>
                  <td valign="top"><b>Specialties</b></td>
                  <td>
                    @for (
                      specialty of credential.specialties;
                      track specialty
                    ) {
                      {{ specialty }}<br />
                    }
                  </td>
                </tr>
              }
            </table>
            @if (
              !credential.application &&
              credential.isRenewalAvailable &&
              !credential.lineupFromSecureLinkId
            ) {
              <button
                [disabled]="!credential.canBeRenewedInPortal || renewalStarted"
                mat-flat-button
                color="primary"
                class="mb-1 primary-button"
                (click)="startRenewal(credential.personCredentialId)"
              >
                Begin Renewal
              </button>
              @if (!credential.canBeRenewedInPortal) {
                <p class="renewal-not-available">
                  Please contact customer support to renew this credential.
                </p>
              }
            }
            @if (
              !credential.application &&
              credential.isRenewalAvailable &&
              credential.lineupFromSecureLinkId
            ) {
              <button
                [disabled]="!credential.canBeRenewedInPortal || renewalStarted"
                mat-flat-button
                color="primary"
                class="mb-1 primary-button"
                (click)="continueRenewal(credential.lineupFromSecureLinkId)"
              >
                Continue Renewal
              </button>
            }
            @if (
              credential.application &&
              credential.credentialStatus.status !== 'PreIssue'
            ) {
              <div class="application-info">
                <div>
                  <p class="application-title">Renewal Application</p>
                  <p class="application-start-date">
                    Started
                    {{ credential.application.startDate | date: 'mediumDate' }}
                  </p>
                </div>
                <div>
                  <div class="application-status">
                    <span>
                      <svg width="10" height="10" class="mr-1">
                        <circle
                          [ngClass]="
                            CredentialStatusLabelColor[
                              credential.application.customApplicationStatus
                                .color
                            ]
                          "
                          class="status-dot"
                          cx="5"
                          cy="5"
                          r="4"
                          stroke-width="0"
                        />
                      </svg>
                      {{
                        credential.application.customApplicationStatus
                          .status === 'InProgress'
                          ? 'In Progress'
                          : credential.application.customApplicationStatus
                              .status
                      }}
                    </span>
                  </div>
                </div>
              </div>
            }
          </section>
        }
      </div>
    }
  }
</div>
